module.exports = __webpack_public_path__ + "media/images/mime_types/file-pdf-o-0f201e1d1a4f862e8a94fcfd12577aa1.png";